import axios from 'axios';
import { BASE_URL } from './api';

export async function getUserConsentLogsByUserId(token, userId) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/user-consent-logs/?user=${userId}`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response
    }).catch((error) => {
        console.error(error) 
        return error
    })
}

export async function createUserConsentLog(token, data) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/user-consent-logs/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        console.error(error)
        return error
    })
}